import { GlButton } from '@gitlab/ui';
import AgentMessage from './message_agent';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const WORKFLOW_NEW_APP = 'workflow-new';
var script = {
  name: 'DuoWorkflowEndMessage',
  components: {
    AgentMessage,
    GlButton
  },
  props: {
    endMessage: {
      required: false,
      type: String,
      default: "Review the changes. To improve the implementation, create another session and describe the specific changes you'd like to see."
    },
    action: {
      required: false,
      type: Object,
      default: null
    }
  },
  computed: {
    route() {
      return this.action && Object.keys(this.action).length > 0 ? undefined : this.$options.newRoute;
    },
    buttonText() {
      var _this$action;
      return ((_this$action = this.action) === null || _this$action === void 0 ? void 0 : _this$action.text) || 'New session';
    }
  },
  newRoute: {
    name: WORKFLOW_NEW_APP
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('agent-message',{attrs:{"message":{ content: _vm.endMessage }},scopedSlots:_vm._u([{key:"message",fn:function(ref){
var content = ref.content;
return [_c('p',[_vm._v("\n      "+_vm._s(content)+"\n    ")]),_vm._v(" "),_c('gl-button',{staticClass:"gl-mt-4",attrs:{"to":_vm.route},on:{"click":function($event){return _vm.$emit('new-flow')}}},[_vm._v(_vm._s(_vm.buttonText))])]}}])})};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
export { WORKFLOW_NEW_APP };
